import { Box, Grid } from "@mui/material";
import React, { useState } from "react";
import Textfield from "../../shared/textfield";


export default function FamilyMedicalHistory(props) {
  const [disabledField, setDisabledField] = useState(true);
  const profile = props.profile;

  return (
    <Box ml={2} mr={2} mb={2}>
      
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Textfield
              title='Family illnesses'
              value={profile.familyInformation?.familyIllnessesHistory}
              disabled={disabledField}
              multiline
              rows={2}
            />
          </Grid>
        </Grid>
    </Box>
  );
}
